import React from 'react'
import PropTypes from 'prop-types'

const SuspendSubscriber = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M15.5696 12.2531L14.5146 11.1981L16.0783 9.61551L14.5146 8.05179L15.5696 6.97791L17.1522 8.56047L18.7159 6.97791L19.7898 8.05179L18.2072 9.61551L19.7898 11.1981L18.7159 12.2531L17.1522 10.6894L15.5696 12.2531ZM9.23938 11.4995C8.41042 11.4995 7.70078 11.2044 7.11046 10.614C6.52014 10.0237 6.22498 9.31407 6.22498 8.48511C6.22498 7.65615 6.52014 6.94651 7.11046 6.35618C7.70078 5.76586 8.41042 5.4707 9.23938 5.4707C10.0683 5.4707 10.778 5.76586 11.3683 6.35618C11.9586 6.94651 12.2538 7.65615 12.2538 8.48511C12.2538 9.31407 11.9586 10.0237 11.3683 10.614C10.778 11.2044 10.0683 11.4995 9.23938 11.4995ZM3.21057 17.5283V15.4182C3.21057 14.9912 3.32047 14.5987 3.54027 14.2407C3.76007 13.8828 4.05209 13.6096 4.41633 13.4212C5.19505 13.0318 5.98634 12.7398 6.79018 12.5451C7.59402 12.3505 8.41042 12.2531 9.23938 12.2531C10.0683 12.2531 10.8847 12.3505 11.6886 12.5451C12.4924 12.7398 13.2837 13.0318 14.0624 13.4212C14.4267 13.6096 14.7187 13.8828 14.9385 14.2407C15.1583 14.5987 15.2682 14.9912 15.2682 15.4182V17.5283H3.21057ZM4.71777 16.0211H13.761V15.4182C13.761 15.2801 13.7264 15.1545 13.6574 15.0414C13.5883 14.9284 13.4972 14.8405 13.3842 14.7777C12.7059 14.4386 12.0214 14.1842 11.3306 14.0147C10.6398 13.8451 9.94274 13.7603 9.23938 13.7603C8.53602 13.7603 7.83894 13.8451 7.14814 14.0147C6.45734 14.1842 5.77281 14.4386 5.09457 14.7777C4.98153 14.8405 4.89047 14.9284 4.82139 15.0414C4.75231 15.1545 4.71777 15.2801 4.71777 15.4182V16.0211ZM9.23938 9.99231C9.65386 9.99231 10.0087 9.84473 10.3038 9.54957C10.599 9.25441 10.7466 8.89959 10.7466 8.48511C10.7466 8.07063 10.599 7.71581 10.3038 7.42065C10.0087 7.12549 9.65386 6.97791 9.23938 6.97791C8.8249 6.97791 8.47008 7.12549 8.17492 7.42065C7.87976 7.71581 7.73218 8.07063 7.73218 8.48511C7.73218 8.89959 7.87976 9.25441 8.17492 9.54957C8.47008 9.84473 8.8249 9.99231 9.23938 9.99231Z"
        fill={color}
      />
    </svg>
  )
}

SuspendSubscriber.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(SuspendSubscriber)
